module.exports = __webpack_public_path__ + "a94135ba0d427e940426b90006326521.svg";